import React from 'react';

export default (
    <svg
        width="19px"
        height="20px"
        viewBox="0 0 19 20"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <g
            id="Event-type"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <rect
                id="Rectangle"
                stroke="#EAC9EF"
                strokeWidth="1.5"
                x="0.75"
                y="1.9124193"
                width="17.5"
                height="16.5"
                rx="2"
            ></rect>
            <path
                d="M6.2628195,0 L6.2628195,3"
                id="Stroke-115-Copy-3"
                stroke="#EAC9EF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></path>
            <path
                d="M12.2628195,0 L12.2628195,3"
                id="Stroke-115-Copy-4"
                stroke="#EAC9EF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></path>
            <path
                d="M1.23977061,6.1624193 L18.0222345,6.1624193"
                id="Stroke-106"
                stroke="#EAC9EF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></path>
            <polygon
                id="Star"
                stroke="#EAC9EF"
                strokeWidth="1.4"
                strokeLinejoin="round"
                points="9.5 14.5 7.14885899 15.736068 7.59788697 13.118034 5.69577393 11.263932 8.3244295 10.881966 9.5 8.5 10.6755705 10.881966 13.3042261 11.263932 11.402113 13.118034 11.851141 15.736068"
            ></polygon>
        </g>
    </svg>
);
